var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257 602 c-10 -10 -14 -22 -10 -25 7 -8 43 21 43 35 0 14 -16 9 -33 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 564 c-57 -40 -69 -136 -27 -221 32 -64 130 -171 192 -211 54 -35 159 -72 200 -72 43 0 96 33 115 71 31 60 25 73 -47 108 -36 17 -71 31 -78 31 -7 0 -25 -16 -40 -35 l-28 -35 -47 24 c-26 13 -63 42 -83 63 -64 69 -63 68 -35 109 l25 37 -20 51 c-31 77 -46 96 -77 96 -15 0 -38 -7 -50 -16z m65 -96 c22 -54 28 -79 20 -87 -31 -31 83 -155 175 -190 22 -8 31 -6 50 8 22 19 24 18 91 -16 38 -19 67 -39 64 -46 -2 -7 -19 -23 -38 -35 -28 -20 -42 -23 -82 -18 -76 8 -184 66 -249 133 -124 126 -161 242 -102 313 15 17 30 28 34 23 4 -4 21 -42 37 -85z m26 48 c22 -46 34 -106 19 -91 -18 17 -62 137 -49 132 7 -2 20 -20 30 -41z m332 -293 c30 -15 55 -33 55 -40 0 -7 -2 -13 -5 -13 -15 0 -125 62 -125 70 0 16 15 12 75 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 322 c0 -5 7 -16 16 -23 14 -12 16 -11 13 5 -4 20 -29 35 -29 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 271 c0 -11 71 -75 100 -91 27 -14 42 -3 15 12 -10 6 -38 28 -61 50 -42 39 -54 45 -54 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 546 c-13 -7 -20 -16 -15 -19 10 -6 74 18 74 28 0 9 -35 5 -59 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 470 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.6917e439004608e92270cb60ab9ba5aa.svg";
export { ForwardRef as ReactComponent };